<template>
  <div class="footer">
    {{ text }}
  </div>
</template>

<script>
import isBnn from '@/config/isBnn'

export default {
  computed: {
    text() {
      return isBnn
        ? 'Copyright © 2024 Bnn. All rights reserved.'
        : 'Copyright © 2024 Studio7Thailand. All rights reserved.'
    },
  },
}
</script>

<style lang="stylus" scoped>
.footer
    background: black
    color: white
    height: 56px
    // margin-top: 2.5rem
    display: flex
    justify-content: center
    align-items: center
    width 100%
    font-size: 14px
    font-weight: bold
    text-align: center
    @media screen and (max-width: 768px)
        // margin-bottom: 150px
</style>
